module.exports = __webpack_public_path__ + "static/img/layout-3.06b3c203.jpg";